import { render, staticRenderFns } from "./TicketChat.vue?vue&type=template&id=7381c880&scoped=true&"
import script from "./TicketChat.vue?vue&type=script&lang=js&"
export * from "./TicketChat.vue?vue&type=script&lang=js&"
import style0 from "./TicketChat.vue?vue&type=style&index=0&id=7381c880&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7381c880",
  null
  
)

export default component.exports